import LoadingText from "components/loadingText"

const CampaignFormLoader = () => {
  return (
    <div
      className="z-[1] fixed top-0 left-0 flex items-center justify-center w-full h-full"
      style={{ backgroundColor: "rgb(148 163 184 / 0.5)" }}
    >
      <LoadingText
        text="Loading"
        render={(text) => (
          <div className="w-[180px] rounded-full p-2 text-center text-3xl font-bold text-white select-none">{text}</div>
        )}
      />
    </div>
  )
}

export default CampaignFormLoader
